import React, { useEffect } from 'react'
import { Fade, Grid, Paper } from '@mui/material'
import { WorkOrderReportDashboard } from '../../../interfaces'
import { useWorkOrderState } from '../../../hooks'
import { useHistory } from 'react-router-dom'
import { CardChart } from '../../Charts/CardChart/CardChart'
import { configDateInitial } from '../../../utils/dateHelper'
import { plannerOT } from '../../../const/locationPaths'

import { WorkOrderReportFilters } from '../../../interfaces/WorkOrder/WorkOrderReportDashboard'

interface WorkOrderReportProps {
  workOrderData: WorkOrderReportDashboard[]
  values: WorkOrderReportFilters
}

export const WorkOrderReport: React.FC<WorkOrderReportProps> = ({
  workOrderData,
  values
}) => {
  const history = useHistory()

  const handleClick = (workOrderStateId: number) => {
    history.push(`/wms/${plannerOT}`, {
      workOrderStateId: workOrderStateId,
      dateToSearch: configDateInitial(0),
      dateType: values.type
    })
  }

  const {
    workOrderStatesState: { workOrderStates },
    getWorkOrderStates
  } = useWorkOrderState()

  useEffect(() => {
    if (workOrderStates?.length === 0) {
      getWorkOrderStates()
    }
  }, [])

  const getWorkOrderStateText = (id: number) => {
    if (workOrderStates === undefined || workOrderStates.length === 0) return ''

    return workOrderStates?.filter((item) => item.workOrderStateId === id)[0]
      .state
  }

  return (
    <Paper
      elevation={3}
      style={{ padding: '10px', minHeight: '140px', marginTop: '20px' }}
    >
      <Fade in={true}>
        <Grid container spacing={2} direction='row'>
          {workOrderData.map((wod: WorkOrderReportDashboard) => (
            <Grid
              item
              xs={12}
              sm={6}
              lg={2}
              key={wod.workOrderStateId}
              style={{
                margin: '0px !important',
                maxWidth: '14%',
                flexBasis: '14%'
              }}
            >
              <CardChart
                action={() => handleClick(wod.workOrderStateId)}
                title={wod.qty.toString()}
                subTitle={getWorkOrderStateText(wod.workOrderStateId)}
                maxWidth={300}
                maxHeight={250}
                minHeight={'100%'}
              />
            </Grid>
          ))}
        </Grid>
      </Fade>
    </Paper>
  )
}
